import { Button, DynamicFormRequiredType, RequiredIndicator } from '@myosh/odin-components';
import React from 'react';

interface FormBuilderButtonFieldProps {
  buttonCaption: string;
  required?: DynamicFormRequiredType;
}

function FormBuilderButtonField({ buttonCaption, required }: FormBuilderButtonFieldProps) {
  return (
    <div className="flex h-12 items-center m-1">
      <Button variant="alternative">{buttonCaption}</Button>
      {required === DynamicFormRequiredType.True && <RequiredIndicator readOnly={false} required={required} />}
    </div>
  );
}

export default FormBuilderButtonField;
